import { Right } from "neetoicons";
import { Dropdown } from "neetoui";

import ProfileHeader from "../ProfileHeader";

const { MenuItem } = Dropdown;

const MenuButton = ({ profileInfo, ...otherProps }) => (
  <MenuItem.Button
    className="neeto-molecules-profile-popup"
    data-testid="profile-expand-menu-button"
    suffix={<Right className="rtl:scale-x-[-1]" size={18} />}
    {...otherProps}
  >
    <ProfileHeader {...{ profileInfo }} />
  </MenuItem.Button>
);

export default MenuButton;
